var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Typography } from "@mui/material";
var Title = function (_a) {
    var children = _a.children;
    return (_jsx(Typography, __assign({ variant: "h4", sx: {
            textAlign: "center",
            padding: "5rem 0px",
            color: "#322060",
            fontWeight: 500,
        } }, { children: children })));
};
export default Title;
